import React from 'react';
import { useTranslation } from 'react-i18next';
import { Plug, PlugZap } from 'lucide-react';
import Tooltip from '../ui/Tooltip';
import { setSettingsModalOpen, setSettingsInitialTab } from '../../store/uiModalStore';

/**
 * Pane header chip for an agent launched with "Attach Apiboo MCP":
 * 'attached' — the agent has a pane-scoped token (Rust memory only,
 * revoked when the pane ends) that carries exactly the user's MCP grants;
 * 'server_off' — the MCP server was off, so the agent started without it.
 * The server is never switched on from here; the chip opens its settings.
 */
export default function PaneMcpChip({ state }) {
  const { t } = useTranslation();
  if (state === 'attached') {
    return (
      <Tooltip content={t('terminalExt.mcpAttachedTip', 'Apiboo MCP attached to this pane — it uses your MCP grants and ends with the pane')} side="bottom">
        <span className="term-pane-chip term-pane-chip--mcp" tabIndex={0}>
          <Plug size={10} aria-hidden />
          {t('terminalExt.mcpAttached', 'MCP')}
        </span>
      </Tooltip>
    );
  }
  if (state === 'server_off') {
    return (
      <Tooltip content={t('terminalExt.mcpNotAttachedTip', 'Apiboo MCP not attached — the MCP server is off. Open MCP settings')} side="bottom">
        <button
          type="button"
          className="term-pane-chip term-pane-chip--mcp-off"
          onClick={(e) => {
            e.stopPropagation();
            setSettingsInitialTab('mcp');
            setSettingsModalOpen(true);
          }}
        >
          <PlugZap size={10} aria-hidden />
          {t('terminalExt.mcpNotAttached', 'MCP off')}
        </button>
      </Tooltip>
    );
  }
  if (state === 'unsafe_path') {
    return (
      <Tooltip
        content={t(
          'terminalExt.mcpUnsafePathTip',
          'Apiboo MCP not attached — the settings path contains characters that cannot be passed to this agent safely'
        )}
        side="bottom"
      >
        <span className="term-pane-chip term-pane-chip--mcp-off" tabIndex={0}>
          <PlugZap size={10} aria-hidden />
          {t('terminalExt.mcpNotAttached', 'MCP off')}
        </span>
      </Tooltip>
    );
  }
  return null;
}
